import React, { Component } from "react";
import { Spinner } from "../../components";
import API from "../../helpers/apiCalls";
import { ResponsiveLine } from "@nivo/line";
import { Box, Divider, Text, Spacer } from "@chakra-ui/layout";
import moment from "moment";
import { connect } from "react-redux";
import UpgradePage from "../../payments/UpgradePage";
import colors from "../../../helpers/colors";
import { APIEndpoint } from "../../helpers/dataStructures";
import {
  CustomTab,
  CustomTabList,
  CustomTabPanels,
  CustomTabsContainer,
  InsetTab,
  InsetTabList,
  InsetTabPanels,
  InsetTabsContainer,
  LineChart,
} from "../../../design_library";
import { linearGradientDef } from "@nivo/core";
import { TabPanel } from "@chakra-ui/react";
var currencyFormatter = require("currency-formatter");

class HistoricalOptionData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      display: false,
      chartData: [],
      volumeChart: [],
      priceChart: [],
      message: "",
    };
  }

  componentDidMount() {
    if (this.props.demo === true) {
      this.setDemoData();
    } else {
      this.getOptionData(this.props.contractName);
    }
  }

  setDemoData = () => {
    const demoDates = [
      "1 Mar 26",
      "2 Mar 26",
      "3 Mar 26",
      "4 Mar 26",
      "5 Mar 26",
      "6 Mar 26",
      "7 Mar 26",
      "8 Mar 26",
    ];

    const toSeries = (id, values) => ({
      id,
      data: demoDates.map((date, index) => ({
        x: date,
        y: values[index],
      })),
    });

    this.setState({
      loading: false,
      display: true,
      message: "",
      dIvChart: [
        toSeries("impliedVolatility", [29.3, 30.1, 28.8, 27.9, 29.5, 30.2, 31.1, 30.4]),
        toSeries("delta", [21.4, 22.6, 20.9, 19.8, 21.2, 22.1, 23.5, 22.8]),
      ],
      gvtrChart: [
        toSeries("rho", [4.2, 4.0, 3.8, 3.9, 4.1, 4.3, 4.2, 4.1]),
        toSeries("theta", [11.8, 12.1, 12.5, 12.9, 13.2, 13.6, 13.1, 12.7]),
        toSeries("vega", [15.2, 15.9, 16.1, 15.7, 15.3, 15.8, 16.4, 16.0]),
        toSeries("gamma", [6.8, 7.1, 7.0, 6.9, 7.2, 7.4, 7.3, 7.1]),
      ],
      priceChart: [
        toSeries("low", [2.14, 2.09, 2.22, 2.28, 2.33, 2.27, 2.31, 2.36]),
        toSeries("high", [2.61, 2.55, 2.67, 2.74, 2.81, 2.77, 2.84, 2.88]),
        toSeries("bid", [2.31, 2.27, 2.39, 2.45, 2.52, 2.47, 2.55, 2.59]),
        toSeries("ask", [2.45, 2.41, 2.54, 2.61, 2.67, 2.63, 2.71, 2.75]),
        toSeries("close", [2.39, 2.35, 2.48, 2.55, 2.60, 2.56, 2.66, 2.70]),
      ],
      volumeChart: [
        toSeries("volume", [904, 1032, 1198, 1107, 1244, 1320, 1296, 1410]),
        toSeries("openInterest", [6380, 6452, 6524, 6608, 6691, 6744, 6802, 6888]),
      ],
    });
  };

  getOptionData = (contractName) => {
    this.setState({ loading: true, display: false });
    API.getHistoricOptionData(APIEndpoint, contractName)
      .then((data) => {
        if (data.success === false) {
          this.setState({
            loading: false,
            display: false,
          });
        } else {
          //

          let array = data.data.dataArray;

          if (this.props.demo === true) {
            array = array.slice(0, 10);
          }

          // if (array.length === 0) {
          //   this.setState({ loading: false, display: false });
          // }
          // else {
          let impliedVolatility = {
            id: "impliedVolatility",
            data: [],
          };
          let lastPrice = {
            id: "lastPrice",
            data: [],
          };
          let rho = {
            id: "rho",
            data: [],
          };
          let theoretical = {
            id: "theoretical",
            data: [],
          };
          let theta = {
            id: "theta",
            data: [],
          };
          let vega = {
            id: "vega",
            data: [],
          };
          let volume = {
            id: "volume",
            data: [],
          };
          let timeValue = {
            id: "timeValue",
            data: [],
          };
          let gamma = {
            id: "gamma",
            data: [],
          };
          let delta = {
            id: "delta",
            data: [],
          };
          let daysBeforeExpiration = {
            id: "daysBeforeExpiration",
            data: [],
          };
          let high = {
            id: "high",
            data: [],
          };
          let low = {
            id: "low",
            data: [],
          };
          let bid = {
            id: "bid",
            data: [],
          };
          let close = {
            id: "close",
            data: [],
          };
          let ask = {
            id: "ask",
            data: [],
          };
          let openInterest = {
            id: "openInterest",
            data: [],
          };

          array.forEach((element, index) => {
            let date = moment(element.updatedAt).format("Do MMM YY");
            impliedVolatility.data.push({
              x: date,
              y: Math.abs(parseFloat(element.impliedVolatility)),
            });
            lastPrice.data.push({
              x: date,
              y: Math.abs(parseFloat(element.lastPrice)),
            });
            rho.data.push({
              x: date,
              y: Math.abs(parseFloat(element.rho)) * 100,
            });
            theta.data.push({
              x: date,
              y: Math.abs(parseFloat(element.theta)) * 100,
            });
            vega.data.push({
              x: date,
              y: Math.abs(parseFloat(element.vega)) * 100,
            });
            volume.data.push({
              x: date,
              y: Math.abs(parseFloat(element.volume)),
            });
            timeValue.data.push({
              x: date,
              y: Math.abs(parseFloat(element.timeValue)),
            });
            gamma.data.push({
              x: date,
              y: Math.abs(parseFloat(element.gamma)) * 100,
            });
            delta.data.push({
              x: date,
              y: Math.abs(parseFloat(element.delta)) * 100,
            });
            daysBeforeExpiration.data.push({
              x: date,
              y: Math.abs(parseFloat(element.daysBeforeExpiration)),
            });
            bid.data.push({ x: date, y: Math.abs(parseFloat(element.bid)) });
            ask.data.push({ x: date, y: Math.abs(parseFloat(element.ask)) });
            high.data.push({ x: date, y: Math.abs(parseFloat(element.high)) });
            low.data.push({ x: date, y: Math.abs(parseFloat(element.low)) });
            close.data.push({
              x: date,
              y: Math.abs(parseFloat(element.close)),
            });
            openInterest.data.push({
              x: date,
              y: Math.abs(parseFloat(element.openInterest)),
            });
          });

          let dIvChart = [impliedVolatility, delta];
          let gvtrChart = [rho, theta, vega, gamma];

          let priceChart = [low, high, bid, ask, close];
          let volumeChart = [volume, openInterest];

          if (priceChart[0].data.length === 0) {
            this.setState({
              loading: false,
              display: false,
              message: "No data available for this contract",
            });
          } else {
            this.setState({
              loading: false,
              dIvChart: dIvChart,
              priceChart: priceChart,
              volumeChart: volumeChart,
              gvtrChart: gvtrChart,
              display: true,
              message: "",
            });
          }
        }
        // }
      })
      .catch(() => {
        this.setState({ loading: false, display: false });
      });
  };

  render() {
    if (this.state.loading) {
      return <Spinner />;
    }

    // if(this.props.settings.profile.subscriptionType !== 'PREMIUM') {
    //   return <UpgradePage/>
    // }

    if (this.state.display === false) {
      return <Text>{this.state.message}</Text>;
    }

    return (
      <>
        <InsetTabsContainer
          borderRadius="12px"
          pt={this.props.demo === true && "180px"}
          justifyContent="center"
        >
          <InsetTabList dark={true} justifyContent="center">
            <InsetTab>Price</InsetTab>
            <InsetTab>Delta & IV</InsetTab>
            <InsetTab>Gamma, Vega, Theta & Rho</InsetTab>
            <InsetTab>Volume</InsetTab>
          </InsetTabList>
          <InsetTabPanels pt="20px">
            {[
              {
                name: "Price chart",
                object: "priceChart",
                legend: "Option price ($)",
                format: (value) => {
                  return currencyFormatter.format(value, { code: "USD" });
                },
              },
              {
                name: "Delta & IV",
                object: "dIvChart",
                legend: "Greek value (%)",
                format: (value) => {
                  return value + "%";
                },
              },
              {
                name: "Gamma, Vega, Theta & Rho",
                object: "gvtrChart",
                legend: "Greek value (%)",
                format: (value) => {
                  return value + "%";
                },
              },
              {
                name: "Volume chart",
                object: "volumeChart",
                legend: "Volume",
                format: (value) => {
                  return value;
                },
              },
            ].map((value, index) => {
              return (
                <TabPanel key={index}>
                  <Box
                    minHeight={this.props.demo === true ? "500px" : "600px"}
                    height={this.props.demo === true ? "500px" : "700px"}
                    overflow="hidden"
                  >
                    {this.props.demo !== true && (
                      <Text fontSize={"22px"} color="var(--white)">
                        {value.name}
                      </Text>
                    )}
                    {this.props.demo !== true && (
                      <Divider pt={"16px"} pb="20px" />
                    )}
                    <Spacer height="20px" />
                    <LineChart
                      curve="linear"
                      yScale={{
                        type: "linear",
                        min: "0",
                        max: "auto",
                        stacked: false,
                        reverse: false,
                      }}
                      data={this.state[value.object]}
                      margin={{ top: 10, right: 60, bottom: 300, left: 80 }}
                      axisBottom={{
                        tickRotation: 45,
                        legendOffset: -80,
                        legendPosition: "start",
                      }}
                      axisLeft={{
                        format: (v) => {
                          return value.format(v);
                        },
                        labelTextColor: "var(--white)",
                      }}
                      gradient={true}
                      tooltipFormat={value.format}
                    />
                  </Box>
                </TabPanel>
              );
            })}
          </InsetTabPanels>
        </InsetTabsContainer>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { settings } = state;
  return { settings };
};

export default connect(mapStateToProps)(HistoricalOptionData);
